/**
 * SlingoStyle.ts
 */
export class SlingoStyle {
}
SlingoStyle.MODULE = "Game";
//Assets
SlingoStyle.LOGO = "Logo";
SlingoStyle.PAY_TABLE = "PayTable";
SlingoStyle.PAY_TABLE_BACKGROUND = "PayTableBackground";
SlingoStyle.MINI_PAY_TABLE_BACKGROUND = "MiniPayTableBackground";
SlingoStyle.PAY_TABLE_FRAME = "PayTableFrame";
SlingoStyle.MINI_PAY_TABLE_FRAME = "MiniPayTableFrame";
SlingoStyle.PORTRAIT_PAY_TABLE_CELL = "WinDisplay";
SlingoStyle.PAY_TABLE_CELL = "WinDisplay";
SlingoStyle.PAY_TABLE_SCATTER = "PayTableScatter";
SlingoStyle.PAY_TABLE_BUTTON = "PayTableButton";
SlingoStyle.PAY_TABLE_ICON = "PayTableIcon";
SlingoStyle.NAVIGATION_BACKGROUND = "NavigationBackground";
SlingoStyle.PURCHASE_SPIN_BUTTON = "PurchaseSpinButton";
SlingoStyle.REEL = "Reel";
SlingoStyle.REEL_BACKGROUND = "ReelBackground";
SlingoStyle.REEL_PURCHASE_BACKGROUND = "ReelBackgroundPurchaseSpins";
SlingoStyle.REEL_NUMBER_ANIMATION = "ReelNumberAnimation";
SlingoStyle.REEL_SYMBOL_ANIMATION = "Symbols";
SlingoStyle.NUMBER = "N";
SlingoStyle.FREE_SPIN = "FS";
SlingoStyle.COIN = "C";
SlingoStyle.DEVIL = "D";
SlingoStyle.SUPER_JOKER = "SJ";
SlingoStyle.JOKER = "J";
SlingoStyle.SPIN_BUTTON = "SpinButton";
SlingoStyle.START_GAME_BUTTON = "SpinButton";
SlingoStyle.REMAINING_SPINS = "SpinsRemainingBackground"; //"UpdateRemainingSpins";
SlingoStyle.REMAINING_FREE_SPINS = "SpinsRemainingFreeSpinsBackground";
SlingoStyle.REMAINING_PURCHASE_SPINS = "SpinsRemainingBackgroundPurchaseSpins";
SlingoStyle.TEST_BUTTON = "TestButton";
SlingoStyle.TICKET_SYMBOL = "TicketSymbol";
SlingoStyle.TICKET_SYMBOL_AVAILABLE_WIN = "TicketSymbolAvailableWin";
SlingoStyle.TICKET_SYMBOL_BUTTON = "TicketSymbolButton";
SlingoStyle.TICKET_SYMBOL_DAB = "TicketSymbolDab";
SlingoStyle.MESSAGE_BAR_BACKGROUND = "NavigationBackground";
SlingoStyle.BACK_TO_GAME_BUTTON = "SpinButton"; //flip horizontally in props
SlingoStyle.REEL_PURCHASE = "ReelPurchaseSpin";
SlingoStyle.REEL_ANIMATION = "ReelAnimation";
SlingoStyle.REEL_SYMBOL = "ReelSymbol";
SlingoStyle.REEL_SYMBOL_DISABLED = "ReelSymbolDisabled";
SlingoStyle.REEL_SYMBOL_HIGHLIGHT = "ReelSymbolHighlight";
SlingoStyle.STAKE_BUTTON = "StakeSelectorToggleButton";
SlingoStyle.SLINGO = "Slingo";
SlingoStyle.GRID_BORDER = "GridBorder";
SlingoStyle.COLLECT_BUTTON = "PurchaseSpinsCollectButton";
SlingoStyle.END_GAME_BUTTON = "PurchaseSpinsCollectButton";
SlingoStyle.STOP_REPLAY_BUTTON = "StopButton";
SlingoStyle.COLLECT_DIALOG = "CollectDialog";
SlingoStyle.GAME_OVER = "GameOver";
SlingoStyle.GAME_SUMMARY = "GameSummary";
SlingoStyle.GAME_SUMMARY_CELL = "GameSummaryCell";
SlingoStyle.GAME_SUMMARY_WIN_BACKGROUND = "GameSummaryWinBackground";
SlingoStyle.GAME_SUMMARY_SLINGO_CELL_ICON = "GameSummarySlingoCellIcon";
SlingoStyle.GAME_SUMMARY_JOKER_CELL_ICON = "GameSummaryJokerCellIcon";
SlingoStyle.GAME_SUMMARY_FULL_HOUSE = "FullHouseSummary";
SlingoStyle.GAME_SUMMARY_BIG_WIN = "BigWinSummary";
///spine anims
SlingoStyle.FULL_HOUSE = "FullHouse";
SlingoStyle.BIG_WIN = "BigWin";
SlingoStyle.BIG_WIN_ANIMATION = "WinAnimation";
SlingoStyle.FULL_HOUSE_ANIMATION = "WinAnimation";
SlingoStyle.SCATTER_WIN_ANIMATION = "WinAnimation";
SlingoStyle.SCATTER_WIN_COUNTER = "ScattersPrizeWinBase";
SlingoStyle.TOTAL_WIN_COUNTER = "TotalWinCounter";
SlingoStyle.FULL_HOUSE_IN_LANDSCAPE = "FullHouseInLandscape";
SlingoStyle.FULL_HOUSE_IN_PORTRAIT = "FullHouseInPortrait";
SlingoStyle.FULL_HOUSE_LOOP_LANDSCAPE = "FullHouseLoopLandscape";
SlingoStyle.FULL_HOUSE_LOOP_PORTRAIT = "FullHouseLoopPortrait";
SlingoStyle.FULL_HOUSE_OUT_LANDSCAPE = "FullHouseOutLandscape";
SlingoStyle.FULL_HOUSE_OUT_PORTRAIT = "FullHouseOutPortrait";
SlingoStyle.BIG_WIN_IN_LANDSCAPE = "BigWinInLandscape";
SlingoStyle.BIG_WIN_IN_PORTRAIT = "BigWinInPortrait";
SlingoStyle.BIG_WIN_LOOP_LANDSCAPE = "BigWinLoopLandscape";
SlingoStyle.BIG_WIN_LOOP_PORTRAIT = "BigWinLoopPortrait";
SlingoStyle.BIG_WIN_OUT_LANDSCAPE = "BigWinOutLandscape";
SlingoStyle.BIG_WIN_OUT_PORTRAIT = "BigWinOutPortrait";
SlingoStyle.SCATTER_WIN_IN_LANDSCAPE = "ScatterWinInLandscape";
SlingoStyle.SCATTER_WIN_IN_PORTRAIT = "ScatterWinInPortrait";
SlingoStyle.SCATTER_WIN_LOOP_LANDSCAPE = "ScatterWinLoopLandscape";
SlingoStyle.SCATTER_WIN_LOOP_PORTRAIT = "ScatterWinLoopPortrait";
SlingoStyle.SCATTER_WIN_OUT_LANDSCAPE = "ScatterWinOutLandscape";
SlingoStyle.SCATTER_WIN_OUT_PORTRAIT = "ScatterWinOutPortrait";
SlingoStyle.SCATTER_SUSPENSE = "SuspenseSpinEffect";
SlingoStyle.OPTIONS_MENU_SOUND_BUTTON = "OptionsMenuSoundButton";
SlingoStyle.OPTIONS_MENU_MUSIC_BUTTON = "OptionsMenuMusicButton";
SlingoStyle.COLLECT_BUTTON_SPINE = "UiElements";
SlingoStyle.COLLECT_BUTTON_LOOP = "CollectButtonLoop";
SlingoStyle.END_GAME_BUTTON_SPINE = "UiElements";
SlingoStyle.END_GAME_BUTTON_LOOP = "CollectButtonLoop";
SlingoStyle.PURCHASE_BUTTON_SPINE = "UiElements";
SlingoStyle.START_GAME_LOOP = "PurchaseSpinLoop";
SlingoStyle.PURCHASE_SPIN_LOOP = "PurchaseSpinLoop";
SlingoStyle.PURCHASE_SPIN_TRANSITION = "spinToPurchaseSpinTransition";
SlingoStyle.FREE_SPINS_OVERLAY_ANIMATION = "free_spins_win";
/**
 * HelpSnapshot.ts
 */
export class HelpSnapshot {
}
HelpSnapshot.START_GAME_BUTTON = "HelpSnapshot.StartGameButton";
HelpSnapshot.PURCHASE_SPIN_BUTTON = "HelpSnapshot.PurchaseSpinButton";
HelpSnapshot.AVAILABLE_WIN_DISPLAY_LANDSCAPE = "HelpSnapshot.AvailableWinDisplayLandscape";
HelpSnapshot.AVAILABLE_WIN_DISPLAY_PORTRAIT = "HelpSnapshot.AvailableWinDisplayPortrait";
HelpSnapshot.COLLECT = "HelpSnapshot.CollectButton";
HelpSnapshot.END_GAME = "HelpSnapshot.EndGameButton";
HelpSnapshot.STAKE_SELECTOR = "HelpSnapshot.StakeSelectorToggleButton";
HelpSnapshot.PAY_TABLE_IN_PROGRESS = "HelpSnapshot.PayTableInProgress";
HelpSnapshot.FREE_SPINS = "HelpSnapshot.FreeSpins";
HelpSnapshot.FREE_SPIN_SYMBOL = "HelpSnapshot.FreeSpinSymbol";
HelpSnapshot.FEATURE_REELS_LANDSCAPE = "HelpSnapshot.FeatureReelsLandscape";
HelpSnapshot.FEATURE_REELS_PORTRAIT = "HelpSnapshot.FeatureReelsPortrait";
HelpSnapshot.FEATURE_REELS_FRAME_LANDSCAPE = "HelpSnapshot.FeatureReelsFrameLandscape";
HelpSnapshot.FEATURE_REELS_FRAME_PORTRAIT = "HelpSnapshot.FeatureReelsFramePortrait";
//# sourceMappingURL=SlingoStyle.js.map